import { render, staticRenderFns } from "./SeasonsList.vue?vue&type=template&id=10f8df34&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f8df34",
  null
  
)

export default component.exports